import { render } from "./MechsLogin.vue?vue&type=template&id=7c61aa6c"
import script from "./MechsLogin.vue?vue&type=script&lang=js"
export * from "./MechsLogin.vue?vue&type=script&lang=js"
script.render = render

export default script